import Banner from '@components/Banner/banner';
import SegmentationFive from './sections/SegmentationFive';
import SegmentationFour from './sections/SegmentationFour';
import SegmentationOne from './sections/SegmentationOne';
import SegmentationThree from './sections/SegmentationThree';
import SegmentationTwo from './sections/SegmentationTwo';
import Footer from '@components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function Segmentations() {
  const { t } = useTranslation('segmentation');
  return (
    <>
      <Banner
        title={t('segmentation.title')}
        paragraph={t('segmentation.subtitle')}
      />
      <SegmentationOne />
      <SegmentationTwo />
      <SegmentationThree />
      <SegmentationFour />
      <SegmentationFive />
      <Footer />
    </>
  );
}

export default Segmentations;
